<template>
  <div class="item" :class="{ noStart: !activityState }" @click="toSuitPlace">
    <div class="sign">套装</div>
    <div class="content">
      <div
        class="content-item"
        v-for="item in data.themeGoodsList"
        :key="item.goodsId"
      >
        <div
          class="img"
          :style="{
            backgroundImage: 'url(' + item.goodsImage + ')',
          }"
        ></div>
      </div>
    </div>
    <div class="head">
      <div class="title">
        <div class="title-l">
          <template v-if="data.activityReward === 'COMMISSION' && $store.state.user.distributionFlag">
            <iframe class="img" :src="require('@/assets/goodsdetail/双倍佣金.svg')"></iframe>
          </template>
          <template v-if="data.activityReward === 'AWARD'">
            <iframe class="img" :src="require('@/assets/goodsdetail/抽奖专场.svg')"></iframe>
          </template>
          <template v-if="data.activityReward === 'NEWBIE'">
            <iframe class="img" :src="require('@/assets/goodsdetail/新人专场.svg')"></iframe>
          </template>
          <span class="van-ellipsis">{{ data.suitName }}</span>
        </div>
        <div class="title-r">
          <Countdown :startTime="data.start" :endTime="data.end" :padding="0" @activityStateChange="activityStateChange" />
        </div>
      </div>
      <div class="tips clearfix">
        <span
          class="van-hairline--surround"
          v-for="(item, index) in coupons"
          :key="index"
          >{{ item.couponName }}</span
        >
        <span
          class="van-hairline--surround"
          v-for="item in data.partServices"
          :key="item.id"
          >{{ item.name }}</span
        >
      </div>
    </div>
    <div class="amount-wrapper">
      <div class="left">
        <span class="prefix">¥</span>
        <span class="value">{{ actPrice }}</span>
        <div class="red-tip">套装下单立减{{ reducePrice }}元</div>
      </div>
      <div class="right">
        <div class="amount" v-distributor="true">
          <div class="profit-price">
            <span class="label">省赚</span>
            <span class="prefix">¥</span>
            <span class="value">{{ saveProfit }}</span>
            <template v-if="data.activityReward === 'COMMISSION'">
              <span class="prefix">*</span>
              <span class="value">2</span>
            </template>
          </div>
        </div>
        <div class="btn" @click.stop="shareClick" v-distributor="true">
          <span>分享赚钱</span>
          <img class="inline" src="@/assets/home/fenxiangzhuanqian.svg" />
        </div>
        <div class="btn" v-distributor="false">
          <span>进入会场</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Countdown from "@/components/activity/Countdown";
import { forwardDetail, priceMarkup } from "@/api/forward";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    coupons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activityState: true
    }
  },
  components: { Countdown },
  computed: {
    actPrice() {
      const count = this.data.themeGoodsList.reduce((total, val) => {
        return total + val.actPrice * 100;
      }, 0);
      return Math.round(count) / 100;
    },
    reducePrice() {
      const count = this.data.themeGoodsList.reduce((total, val) => {
        return total + val.reducePrice * 100;
      }, 0);
      return Math.round(count) / 100;
    },
    saveProfit() {
      const count = this.data.themeGoodsList.reduce((total, val) => {
        return total + val.saveProfit * 100;
      }, 0);
      return Math.round(count) / 100;
    },
  },
  methods: {
    toSuitPlace() {
      const routeName = this.$route.name
      if (routeName === 'ActivityPlace') {
        this.$router.push({ path: '/activityPlace/' + this.$route.params.aid + '/suitGoods', query: { suitId: this.data.suitId, suitName: this.data.suitName, actName: this.data.actName } })
      } else if (routeName === 'Newcomer') {
        this.$router.push({ name: 'NewcomerSuitGoods', query: { suitId: this.data.suitId, suitName: this.data.suitName, actName: this.data.actName } })
      } else {
        this.$router.push({ name: 'HomeSuitGoods', query: { suitId: this.data.suitId, suitName: this.data.suitName, actName: this.data.actName } })
      }
    },
    async shareClick() {
      if (this.data.themeGoodsList[0]?.state === 'FINISHED') {
        Toast({
          message: '活动已结束',
          position: "center",
          duration: 1000,
        })
        return
      }
      try {
        this.$store.dispatch("app/showLoading");
        const detail = await this.getSharePosterDetail({
          actId: this.data.actId,
          suitId: this.data.suitId,
          forwardType: "SUIT",
        });
        const forwardUrl =
          `${window.location.origin}/homeSuitGoods?` +
          `suitId=${this.data.suitId}&suitName=${this.data.suitName}&actName=${this.data.signBrandId}&actName=${this.data.actName}&` +
          `customerId=${this.$store.state.user.forwardId}`;
        const img = await this.getSharePosterImg({
          suitId: this.data.suitId,
          actId: this.data.actId,
          forwardType: "SUIT",
          price: detail.price,
          urlAddress: forwardUrl,
        });

        this.sharePosterOpen(img.url, forwardUrl);
        this.$store.dispatch("app/hideLoading");
      } catch (error) {
        this.$store.dispatch("app/hideLoading");
      }
    },
    sharePosterOpen(url, forwardUrl) {
      this.$store.dispatch("sharePoster/show", {
        url,
        title: this.data.suitName,
        desc: this.data.actName,
        link: forwardUrl,
        imgUrl: this.data.themeGoodsList[0]?.goodsImage,
      });
    },
    // 获取海报数据
    getSharePosterDetail(data) {
      return new Promise((resolve, reject) => {
        forwardDetail(data)
          .then((res) => {
            resolve(res.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 生成海报图片
    getSharePosterImg(data) {
      return new Promise((resolve, reject) => {
        priceMarkup(data)
          .then((res) => {
            resolve(res.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 实时获取开始状态
    activityStateChange(flag) {
      this.activityState = flag
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  position: relative;
  background-color: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  text-align: left;
  & + .item {
    margin-top: 24px;
  }
  .sign {
    position: absolute;
    left: 32px;
    top: 0;
    background-color: #e82035;
    width: 60px;
    height: 30px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    line-height: 16px;
    text-align: center;
    padding-top: 4px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    &::after {
      position: absolute;
      content: "";
      left: 0;
      bottom: 0;
      width: 0;
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 30px solid transparent;
      border-right: 30px solid transparent;
      border-bottom: 6px solid #fff;
    }
  }
  .head {
    padding: 14px 32px 20px;
    .title {
      display: flex;
      justify-content: space-between;
      &-l {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;
        font-weight: bold;
        color: #333;
        .img {
          display: inline-block;
          height: 30px;
          width: 104px;
          margin-right: 8px;
        }
        span {
          line-height: 24px;
          font-size: 24px;
        }
      }
    }
    .tips {
      padding-top: 12px;
      height: 50px;
      overflow: hidden;
      span {
        float: left;
        display: block;
        font-size: 16px;
        line-height: 16px;
        font-weight: 400;
        color: #e82035;
        padding: 9px 10px;
        margin-right: 8px;
        margin-bottom: 100px;
        &::after {
          border-color: #e82035;
          border-radius: 12px;
        }
      }
    }
  }
  .content {
    padding: 32px 32px 0;
    overflow-x: scroll;
    display: flex;
    white-space: nowrap;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .content-item {
      display: inline-block;
      width: 120px;
      & + .content-item {
        margin-left: 10px;
      }
      .img {
        width: 120px;
        height: 120px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border-radius: 10px;
      }
    }
  }
  .amount-wrapper {
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
    padding: 0 34px 20px 32px;
    .left {
      display: flex;
      align-items: flex-end;
      .prefix {
        font-size: 24px;
        margin-right: 4px;
        line-height: 24px;
        font-weight: 800;
        color: #e82035;
      }
      .label {
        font-size: 24px;
        font-weight: 600;
        color: #333333;
        line-height: 28px;
        padding-right: 8px;
      }
      .prefix {
        font-size: 24px;
        line-height: 24px;
        font-weight: 800;
        color: #333333;
      }
      .value {
        font-size: 32px;
        line-height: 32px;
        font-weight: 800;
        color: #333333;
        line-height: 34px;
      }
      .red-tip {
        margin-left: 14px;
        position: relative;
        background-color: #e82035;
        border-radius: 8px;
        color: #fff;
        font-size: 16px;
        line-height: 16px;
        padding: 6px 10px;
        margin-bottom: 2px;
        &::after {
          position: absolute;
          content: "";
          left: -10px;
          top: 9px;
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-right: 10px solid #e82035;
          border-bottom: 5px solid transparent;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      .amount {
        margin-right: 20px;
        .profit-price {
          display: flex;
          align-items: flex-end;
          color: #e82035;
          .label {
            font-size: 20px;
            line-height: 28px;
            font-weight: 800;
          }
          .prefix {
            font-size: 20px;
            line-height: 28px;
            font-weight: 800;
          }
          .value {
            font-size: 24px;
            line-height: 30px;
            font-weight: 800;
          }
        }
      }
      .btn {
        display: flex;
        align-items: center;
        background-color: #e82035;
        padding: 8px 12px;
        border-radius: 24px;
        span {
          font-size: 24px;
          line-height: 24px;
          font-weight: 400;
          color: #ffffff;
        }
        img {
          width: 24px;
          margin-left: 8px;
        }
      }
    }
  }
}

.item.noStart {
  .amount-wrapper .right .btn {
    background-color: #44D7B6;
  }
  .amount-wrapper .right .amount .profit-price {
    color: #44D7B6;
  }
}
</style>